import { render } from "./Contact.vue?vue&type=template&id=333da1ea&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=333da1ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-333da1ea"

export default script